module.exports = new Promise((resolve) => {
    const baseUrl = (window.RUNTIME && window.RUNTIME['PAYROLL_REMOTE_URL']) || '';

    if (!baseUrl) {
      console.error('Missing payroll remote URL');
      return resolve({
        get: () => Promise.reject(new Error('Missing payroll remote URL')),
        init: () => {}
      });
    }

    const remoteUrl = (() => {
      const separator = baseUrl.includes('?') ? '&' : '?';
      return `${baseUrl}${separator}t=${Date.now()}`;
    })();

    if (window['adjustmentsApp']) {
      const existingContainer = window['adjustmentsApp'];
      return resolve({
        get: (request) => existingContainer.get(request),
        init: (arg) => {
          try {
            return existingContainer.init(arg);
          } catch (_) {}
        }
      });
    }

    const existingScript = document.querySelector('script[data-mf-remote="adjustmentsApp"]');
    if (existingScript) {
      existingScript.addEventListener('load', () => {
        const container = window['adjustmentsApp'];
        if (!container) {
          return resolve({
            get: () => Promise.reject(new Error('adjustmentsApp not found')),
            init: () => {}
          });
        }

        resolve({
          get: (request) => container.get(request),
          init: (arg) => {
            try {
              return container.init(arg);
            } catch (_) {}
          }
        });
      });

      existingScript.addEventListener('error', () => {
        resolve({
          get: () => Promise.reject(new Error('Failed loading payroll remote')),
          init: () => {}
        });
      });

      return;
    }

    const el = document.createElement('script');
    el.src = remoteUrl;
    el.type = 'text/javascript';
    el.async = true;
    el.crossOrigin = 'anonymous';
    el.dataset.mfRemote = 'adjustmentsApp';

    el.onload = () => {
      const container = window['adjustmentsApp'];
      if (!container) {
        console.error('Remote container "adjustmentsApp" not found on window');
        return resolve({
          get: () => Promise.reject(new Error('adjustmentsApp not found')),
          init: () => {}
        });
      }

      resolve({
        get: (request) => container.get(request),
        init: (arg) => {
          try {
            return container.init(arg);
          } catch (_) {}
        }
      });
    };

    el.onerror = () => {
      console.error('Failed to load remoteEntry:', remoteUrl);
      el.remove();
      resolve({
        get: () => Promise.reject(new Error('Failed loading payroll remote')),
        init: () => {}
      });
    };

    document.head.appendChild(el);
  })
;